<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            svg(width='100%' height='100%' viewBox='0 0 1280 720' preserveAspectRatio='xMidYMid meet')
                rect(x='0' y='111' width='100%' height='26' fill='black')
                rect(x='0' y='346' width='100%' height='26' fill='black')
                rect(x='0' y='-124' width='100%' height='26' fill='black')
                rect(x='0' y='-359' width='100%' height='26' fill='black')
                rect(x='0' y='-594' width='100%' height='26' fill='black')
                rect(x='0' y='-829' width='100%' height='26' fill='black')
                rect(x='148' y='-150%' width='26' height='250%' fill='black')
                rect(x='389' y='-150%' width='26' height='250%' fill='black')
                rect(x='630' y='-150%' width='24' height='250%' fill='black')
                rect(x='869' y='-150%' width='24' height='250%' fill='black')
                rect(x='1108' y='-150%' width='24' height='250%' fill='black')
                rect(x='0' y='581' width='100%' height='250%' fill='black')
                g(ref='padlock')
                    g(ref='key')
                        path(d='M1019.61 435.89L897.73 435.498C896.502 428.934 894.634 422.447 892.117 416.044C892.052 415.903 891.967 415.79 891.865 415.702C891.754 415.588 891.635 415.492 891.499 415.412C884.404 412.601 873.867 410.987 859.878 410.567C855.403 410.451 850.107 410.849 843.985 411.782C837.752 412.719 834.503 413.623 834.224 414.5C828.119 426.059 824.979 440.001 824.795 456.326C824.619 471.327 826.906 485.257 831.657 498.11C831.713 498.268 831.798 498.406 831.912 498.515C832.023 498.628 832.163 498.712 832.336 498.772C852.072 504.923 871.025 505.203 889.193 499.609C889.352 499.536 889.494 499.438 889.612 499.323C889.73 499.232 889.823 499.109 889.883 498.952C892.683 492.197 894.858 485.51 896.415 478.871L918.482 478.511C918.669 478.517 918.852 478.461 919.04 478.35C919.212 478.248 919.347 478.109 919.436 477.94L923.635 469.983L937.387 469.874C937.545 469.868 937.691 469.832 937.833 469.767C937.975 469.702 938.1 469.604 938.198 469.468L942.722 463.925L947.198 463.755L950.127 469.461C950.228 469.632 950.371 469.77 950.548 469.876C950.701 469.956 950.883 469.991 951.09 469.977L962.621 469.974C962.8 469.971 962.975 469.923 963.138 469.821C963.305 469.724 963.44 469.584 963.55 469.411L966.247 464.874L969.665 470.062C969.767 470.217 969.902 470.33 970.075 470.407C970.223 470.491 970.389 470.526 970.576 470.524L987.17 470.701C987.406 470.699 987.627 470.623 987.85 470.471C988.043 470.316 988.17 470.118 988.236 469.89L989.532 465.207L995.699 470.838C995.903 471.022 996.155 471.112 996.45 471.103C996.745 471.093 996.995 470.988 997.202 470.778L1002.08 465.804L1016.32 465.708C1016.48 465.714 1016.63 465.678 1016.79 465.605C1016.94 465.532 1017.05 465.438 1017.13 465.31L1028.34 451.301C1028.49 451.128 1028.57 450.938 1028.6 450.714C1028.6 450.503 1028.56 450.295 1028.49 450.095L1028.34 449.849C1028.29 449.79 1028.26 449.732 1028.23 449.673L1024.82 443.797C1024.78 443.713 1024.74 443.647 1024.72 443.601L1020.55 436.418C1020.43 436.255 1020.3 436.125 1020.15 436.036C1019.99 435.931 1019.8 435.879 1019.61 435.89ZM850.556 436.167L850.248 476.529C847.069 477.43 843.596 477.399 839.83 476.436C837.308 464.125 837.424 450.704 840.167 436.169C843.638 434.573 847.102 434.571 850.556 436.167Z' fill='black')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M1075.58 398H1069.51H1047.46H942.434C941.087 398 940 399.088 940 400.435V511.139C940 512.487 941.087 513.574 942.434 513.574H1075.57C1076.91 513.574 1078 512.487 1078 511.139V400.435C1078.02 399.088 1076.93 398 1075.58 398ZM1015.85 473.48V456.696C1019.91 454.293 1022.64 449.878 1022.66 444.83C1022.66 437.185 1016.46 431 1008.83 431C1001.18 431 995 437.201 995 444.83C995 449.878 997.71 454.293 1001.77 456.696V473.48C1001.77 477.376 1004.92 480.541 1008.81 480.541C1012.69 480.541 1015.85 477.376 1015.85 473.48Z' fill='black')
                g(ref='padlockHand')
                    path(d='M1069.02 353.514V493.5L1046.97 495.038V353.514C1046.97 342.866 1042.68 333.305 1035.7 326.309C1028.71 319.329 1019.17 315.044 1008.5 315.044C997.857 315.044 988.298 319.329 981.303 326.309C974.324 333.305 970.04 342.85 970.04 353.514V400.285L960.74 411.193V414.521H970.04V425.462H948V353.514C948.016 320.092 975.087 293 1008.52 293C1041.94 293 1069.02 320.092 1069.02 353.514Z' fill='black')

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(this.$refs.key, {x: -1300}, 0)
                .set(this.$refs.padlock, {y: 0, rotate: 0}, 0)
                .set(this.$refs.padlockHand, {y: 0, rotate: 0}, 0)
                .fromTo(this.$refs.key, {x: -1300}, {duration: 1, x: 20}, 0)
                .fromTo(this.$refs.padlock, {y: 0, rotate: 0}, {duration: 0.7, y: 400, rotate: 100})
                .fromTo(this.$refs.padlockHand, {duration: 1, y: 0, rotate: 0}, {duration: 1, transformOrigin: '50% 12%', y: 90, rotate: 110}, 1)
                .fromTo(this.$refs.padlockHand, {duration: 1, y: 90, rotate: 110}, {duration: 1, y: 450, rotate: 160}, 2);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 190vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: var(--theme);
}

.rocket {
    margin: 0 10px;
    height: 100vh;
    display: flex;
    align-items: center;
    &_wrp {
        height: fit-content;
    }
    img {
        display: block;
        width: 100%;
        height: 100%;
    }
}
</style>
